import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/seoData';

export default function SEOArticles() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-primary-500 uppercase tracking-widest mb-3">
            Shopping Guides
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Master Spreadsheet Shopping
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            Everything you need to know about the itaobuy spreadsheet shopping system — from beginner tutorials to expert strategies
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {allArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/50 hover:border-primary-200/60 overflow-hidden transition-all cursor-pointer"
            >
              {/* Article thumbnail */}
              <div className="w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                  loading="lazy"
                />
              </div>
              {/* Content */}
              <div className="flex flex-col flex-1 p-5">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-6 h-6 rounded-md bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-article-line text-accent-600 text-xs"></i>
                  </div>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.shortTitle}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                  {article.sections[0].content.slice(0, 120)}...
                </p>
                <div className="mt-4 pt-3 border-t border-background-200/40 flex items-center justify-between">
                  <span className="text-xs text-primary-500 font-medium flex items-center gap-1">
                    Read Article
                    <i className="ri-arrow-right-line text-xs group-hover:translate-x-0.5 transition-transform"></i>
                  </span>
                  <span className="text-xs text-foreground-400">{article.sections.length} min read</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}